import { render, staticRenderFns } from "./CompraPorPeriodo.vue?vue&type=template&id=acf38c90&scoped=true&"
import script from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"
export * from "./CompraPorPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./CompraPorPeriodo.vue?vue&type=style&index=0&id=acf38c90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf38c90",
  null
  
)

export default component.exports